<div class="dashboard-container">
    <div class="chart-wrapper">
        <div *ngIf="isLoading" class="loading-state">
            <div class="spinner"></div>
            <p>Loading chart data...</p>
        </div>
        <canvas
            *ngIf="!isLoading"
            baseChart
            [datasets]="comboChartData"
            [labels]="comboChartLabels"
            [options]="comboChartOptions"
            [chartType]="comboChartType"
            [legend]="true">
        </canvas>
    </div>

    <div class="chart-wrapper">
        <div *ngIf="isLoading" class="loading-state">
            <div class="spinner"></div>
            <p>Loading chart data...</p>
        </div>
        <canvas
            *ngIf="!isLoading"
            baseChart
            [data]="pieChartData"
            [labels]="pieChartLabels"
            [options]="pieChartOptions"
            [colors]="pieChartColors"
            [chartType]="pieChartType"
            [legend]="true">
        </canvas>
    </div>
</div>
